import React from "react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "../ui/Collapsible";

const PropertyPanelSection = ({
  title,
  children,
  actions = null,
  actionsClassName,
  ariaLabel,
  defaultOpen = true,
  open,
  onOpenChange,
  unmountOnClose = false,
  contentClassName = "pt-2 space-y-2",
}) => {
  const collapsibleProps = open === undefined ? { defaultOpen } : { open, onOpenChange };

  return (
    <Collapsible {...collapsibleProps}>
      <CollapsibleTrigger
        quiet
        aria-label={ariaLabel}
        actions={actions}
        actionsClassName={actionsClassName}
      >
        {typeof title === "string" ? (
          <span className="min-w-0 truncate text-left">{title}</span>
        ) : (
          title
        )}
      </CollapsibleTrigger>
      <CollapsibleContent unmountOnClose={unmountOnClose}>
        <div className={contentClassName}>{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default React.memo(PropertyPanelSection);
